import * as LocalStorageService from '@/services/LocalStorageService'

export const storeActions = {
  // just a test
  increment()
  {
    this.count++
    LocalStorageService.saveState()
  },

  setProperty(key, value, parentKey)
  {
    if (parentKey){
      this[parentKey][key] = value
    } else {
      this[key] = value
    }
    LocalStorageService.saveState()
  },

  unsetProperty(key, parentKey)
  {
    if (parentKey){
      this[parentKey][key] = null
    } else {
      this[key] = null
    }
    LocalStorageService.saveState()
  },

  startLoading(key)
  {
    this.system.loading[key] = true
  },
  finishedLoading(key)
  {
    this.system.loading[key] = false
  }

}